// import type { FunctionComponent } from 'react';
// import { JsonView } from 'react-json-view-lite';
import { Button, Loader } from '@kanda-libs/ks-design-library';

import Profile from 'components/shared/Profile';

import StringColumn from './StringColumn';

// import { BusinessConfig, LenderConfig } from '@kanda-libs/ks-frontend-services';

// import Profile from 'components/shared/Profile';

// export interface CompanyFinanceDetailsProps {
//   fca?: string;
//   lenderConfigs?: LenderConfig[];
//   businessConfig?: BusinessConfig;
// }

// const CompanyFinanceDetails: FunctionComponent<CompanyFinanceDetailsProps> =
//   function ({ fca, lenderConfigs, businessConfig }) {
//     if (!fca && !lenderConfigs) return null;

//     return (
//       <Profile.Section title="Finance Details" className="pb-4 mb-6 text-left">
//         <>{fca ? <Profile.Property label="FCA number" value={fca} /> : null}</>
//         <>
//           {lenderConfigs ? <JsonView data={{ lenderConfigs }} /> : null}
//           {businessConfig ? <JsonView data={{ businessConfig }} /> : null}
//         </>
//       </Profile.Section>
//     );
//   };

// export default CompanyFinanceDetails;

export interface RateRequestListProps {
  toAdd?: string[];
  toRemove?: string[];
  isSubmitting: boolean;
  onClick: () => void;
}

const RateRequestList: React.FunctionComponent<RateRequestListProps> =
  function ({ isSubmitting, onClick, toAdd, toRemove }) {
    return (
      <Profile.Section
        title="Rate Requests"
        className="flex flex-col pb-4 mb-6 text-left"
      >
        <Profile.Property
          label="Rates To Add"
          value={toAdd ? <StringColumn strings={toAdd} /> : 'No rates to add'}
        />
        <div className="mt-2 mb-3 border-b border-neutral-300" />
        <Profile.Property
          label="Rates To Remove"
          value={
            toRemove ? (
              <StringColumn strings={toRemove} />
            ) : (
              'No rates to remove'
            )
          }
        />
        <Button.Text
          label="Approve"
          id="rate-request-staff-approve"
          className="mt-6"
          size={40}
          onClick={onClick}
          disabled={isSubmitting}
        />
        <Loader isLoading={isSubmitting} />
      </Profile.Section>
    );
  };

export default RateRequestList;
